import { render, staticRenderFns } from "./select-fontes-pagadoras.vue?vue&type=template&id=72ed87ac"
import script from "./select-fontes-pagadoras.vue?vue&type=script&lang=ts"
export * from "./select-fontes-pagadoras.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports